(function () {
  if (window.__rtCategorySliderBound) {
    return;
  }
  window.__rtCategorySliderBound = true;

  function initSliders() {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn || !window.jQuery.fn.slick) {
      return;
    }
    window
      .jQuery('[id^="rt-category_slider-"] .rt-category-slider')
      .each(function () {
        var $el = window.jQuery(this);
        if ($el.hasClass('slick-initialized')) {
          return;
        }
        $el.slick({
          slidesToShow: 5.5,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 4 } },
            { breakpoint: 992, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2.5, arrows: false } },
            { breakpoint: 480, settings: { slidesToShow: 2.5, arrows: false } },
          ],
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
  document.addEventListener('shopify:section:load', initSliders);
})();
